// removed by extract-text-webpack-plugin
module.exports = {"card":"_1rE-7gA3tctQFoC7u69qkp","text":"_2rQCTx2PcuxMvT1tV73uC0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InfographicsCard/InfographicsCard.module.scss
// module id = 781
// module chunks = 0